export default "__VITE_ASSET__D0WD5Qdj__"